import GroupApi from 'mewe/api/group-api';
import GroupCountersStore from 'mewe/stores/group-counters-store';
import GroupStore from 'mewe/stores/group-store';

export default function (groupId) {
  if (!groupId) {
    console.warn('Missing groupId - fetch-group-counters');
    return;
  }

  GroupApi.getCounters(groupId).then((data) => {
    data.admins = data.admins + 1;

    GroupCountersStore.send('handle', groupId, data);

    let confirmedGroup = GroupStore.getState({ id: groupId });
    if (confirmedGroup) {
      confirmedGroup.set('membersCount', data.members);

      if (confirmedGroup.isOwnerAdmin) {
        confirmedGroup.set('applicantsCount', data.pending);
      }
    }
  });
}
